<template>
  <div class="options-card">
    <div class="options-card__header">
      <slot name="title" />
    </div>
    <div class="options-card__content">
      <slot name="subheader" />
      <slot name="content" />
      <div class="options-card__action-area">
        <slot name="actions" />
      </div>
    </div>
  </div>
</template>

<style lang="less" scoped>
@import (reference) '~_acaAssets/wkce/colors/wkce-app-styles';
@PRIMARY-CARD-BG-COLOR: @WKCE-BLUE-TINT6;

.options-card {
  border: @DS1-UTD-GRAY-SINGLE-BORDER;

  .options-card__subtext {
    .ds1-utd-size-2();
    color: @DS1-UTD-SUB-TEXT-COLOR;
  }

  .options-card__action-area {
    display: flex;
    justify-content: flex-end;
    flex-wrap: wrap-reverse;
  }

  .options-card__content {
    .ds1-pa-3();
    .ds1-pt-0();
  }

  .options-card__sticky-note {
    background: @DS1-UTD-JS2-INACTIVE-HOVER-BG-COLOR;
    border: 1px solid @DS1-UTD-ACCOUNT-BUTTON-DISABLED-BG-COLOR;
    border-right: none;
    border-top: none;
    .ds1-flex-horizontal-center();
    height: 29px;
    width: 197px;
  }

  .options-card__sticky-text {
    .ds1-mr-1();
    .ds1-utd-weight-bold();
    font-size: 13px;
    align-self: center;
    color: @DS1-UTD-JS2-LINK-HOVER;
  }
}

.primary-card {
  border-top: @DS1-UTD-PRIMARY-CARD-BORDER;
  background: @PRIMARY-CARD-BG-COLOR;

  .options-card__header {
    .ds1-pa-3();
    .ds1-pb-0();
    display: flex;
    flex: 1;
    justify-content: flex-start;
    position: relative;
  }
}

.secondary-card {
  border-top: @DS1-UTD-SECONDARY-CARD-BORDER;

  .options-card__header {
    .ds1-pt-2();
    .ds1-ph-3();
    .ds1-pb-1();
  }
}
</style>